import React from "react";
import { Link } from "react-router-dom";

/**
 * Premium empty-state placeholder.
 *  - Icon (lucide component or emoji)
 *  - Title + subtitle
 *  - Optional CTA (button or link)
 *  - Renders inside a card-sharp container with subtle pitch-field bg.
 */
export default function EmptyState({
  icon: Icon,
  title,
  description,
  cta,
  ctaTo,
  ctaOnClick,
  testId = "empty-state",
  compact = false,
}) {
  return (
    <div
      className={`card-sharp relative overflow-hidden ${compact ? "p-8" : "p-12"} text-center`}
      data-testid={testId}
    >
      <div className="absolute inset-0 pitch-field opacity-20 pointer-events-none" />
      <div className="relative">
        {Icon && (
          <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-pitch/8 border border-pitch/25 mb-4">
            <Icon className="w-6 h-6 text-pitch" />
          </div>
        )}
        {title && (
          <div className="font-oswald uppercase text-xl tracking-tight mb-2">{title}</div>
        )}
        {description && (
          <div className="text-white/40 text-xs font-mono tracking-wide max-w-sm mx-auto leading-relaxed">{description}</div>
        )}
        {cta && (ctaTo ? (
          <Link
            to={ctaTo}
            className="inline-flex items-center gap-1.5 mt-5 btn-primary px-5 py-2.5 text-xs"
            data-testid={`${testId}-cta`}
          >
            {cta}
          </Link>
        ) : (
          <button
            onClick={ctaOnClick}
            className="inline-flex items-center gap-1.5 mt-5 btn-primary px-5 py-2.5 text-xs"
            data-testid={`${testId}-cta`}
          >
            {cta}
          </button>
        ))}
      </div>
    </div>
  );
}
